import { REQUIRED_FIELDS_ARRAY } from './REQUIRED_FIELDS';
import { MISSING_FIELDS_ARRAY } from './MISSING_FIELDS';

export default function getBucketParams(timestamp) {
  return {
    active: {
      $and: [
        ...REQUIRED_FIELDS_ARRAY,
        {
          cancelled: false
        },
        {
          completed: false
        },
        {
          $or: [
            {
              $and: [
                {
                  specificDate: 'Yes'
                },
                {
                  date: {
                    $gte: timestamp
                  }
                }
              ]
            },
            {
              $and: [
                {
                  specificDate: 'No'
                },
                {
                  endDate: {
                    $gte: timestamp
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    draft: {
      $and: [
        {
          cancelled: false
        },
        {
          completed: false
        },
        {
          $or: [
            ...MISSING_FIELDS_ARRAY
          ]
        }
      ]
    },
    past: {
      $or: [
        {
          cancelled: true
        },
        {
          completed: true
        }
      ],
    },
    // A resource is still active through the entirety of its date, so
    // "expired" ($lt, not $lte) only starts the day after - this needs to
    // stay the exact complement of the $gte used by "active" (and by
    // REQUIRED_FIELDS_PUBLIC). See isExpired in utils/dateTimeUtils.
    expired: {
      $and: [
        ...REQUIRED_FIELDS_ARRAY,
        {
          cancelled: false
        },
        {
          completed: false
        },
        {
          $or: [
            {
              $and: [
                {
                  specificDate: 'Yes'
                },
                {
                  date: {
                    $lt: timestamp
                  }
                }
              ]
            },
            {
              $and: [
                {
                  specificDate: 'No'
                },
                {
                  endDate: {
                    $lt: timestamp
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  };
}
